<!--
 * @Description: 登录（PC3.0）
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="resetForms" :footer-hide="true">
    <div :class="['container-wrapper', language]">
      <img :src="static_img_url + 'pic/modal-bg.png?v=' + $store.state.imgVersion" class="model-bg" v-if="language == 'zh'" />
      <img :src="static_img_url + 'pic/modal-bg-en.png?v=' + $store.state.imgVersion" class="model-bg" v-else />
      <div class="container-content">
        <div class="container-top">
          <div class="container-title">CSGCT</div>
          <Form ref="code-form" :model="codeForm" :rules="ruleValidate">
            <FormItem prop="email">
              <div class="mobile-ipt">
                <Input type="text" v-model="codeForm.email" placeholder="Please enter your email address" autocomplete="off"></Input>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="codeForm.code" placeholder="Please enter verification code" autocomplete="off"></Input>
              <Captcha ref="captcha" scene="vbdata_loginon" :email="codeForm.email" validMode="2" v-if="modelIndex"></Captcha>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom">
          <Button class="submit-btn" type="primary" @click="handleSubmitEn">Sign in with Email</Button>
          <div class="other">
            <div class="other-font">
              <span>Other</span>
            </div>
            <div class="other-container">
              <GoogleLogin @success="handleGoogleLoginSuccess"></GoogleLogin>
              <LinkedinLogin @success="handleLinkedInLoginSuccess"></LinkedinLogin>
              <AppleLogin @success="handleAppleLoginSuccess"></AppleLogin>
            </div>
          </div>
          <div class="checkbox-container">
            By continuing, you agree to the CSGCT <a :href="index2_path+'/mobile/privacyPolicy/12'" target="_blank">Terms of Service</a>
            <br>
            and confirm that you have read our <a :href="index2_path+'/mobile/privacyPolicy/11'" target="_blank">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { editXuserChannelByLocalShareChannelId } from 'js/shareChannel'
import { loginCommon } from '@/assets/js/login'
import { mapState } from 'vuex'
import Captcha from '@/components/common/captcha'
import LinkedinLogin from '@/components/common/linkedinLogin'
import GoogleLogin from '@/components/common/googleLogin'
import AppleLogin from '@/components/common/appleLogin'

export default {
  mixins: [loginCommon],
  inject: ['reload', 'checkIfThereAreSendTickets'],
  components: { Captcha, LinkedinLogin, GoogleLogin, AppleLogin },
  data() {
    return {
      modelIndex: false,
      loginWay: 'code-form',
      codeForm: {
        email: '',
        code: '',
      },
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
    }),
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    loginSuccess(data) {
      this.$Message.success('Login successful')

      this.$store.commit('updateUserKey', data.userKey)
      this.$store.commit('updateUser', data.xuser)
      this.$store.commit('setUUserId', data.xuser.id)
      // return
      this.modelIndex = false
      document.body.removeAttribute('style')

      this.reload()
      this.checkIfThereAreSendTickets()

      editXuserChannelByLocalShareChannelId(this.$store.state.activityId)
      if (this.successCb) this.successCb()
    },
    resetForms(value) {
      if (!value) {
        this.successCb = ''
        this.clearForms()
      }
    },
    clearForms() {
      this.$refs['code-form'].resetFields()
    },
    /**
     * 谷歌登录授权成功回调
     */
    handleGoogleLoginSuccess(response) {
      const token = response && response.credential ? response.credential : null
      if (!token) return
      try {
        this.thirdPartyLogin(token, 9)
      } catch (err) {
        console.error('谷歌登录请求后端失败', err)
      }
    },
    /**
     * 领英登录授权成功回调
     */
    async handleLinkedInLoginSuccess(code) {
      try {
        this.thirdPartyLogin(code, 8)
      } catch (err) {
        console.error('领英登录请求后端失败', err)
      }
    },
    /**
     * 苹果登录授权成功回调
     */
    async handleAppleLoginSuccess(res) {
      const { code, state } = res
      try {
        this.thirdPartyLogin(code, 10)
      } catch (err) {
        console.error('苹果登录请求后端失败', err)
      }
    },
  },
  created() {},
  mounted() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/login.styl'
.other-container
  width 100%
  & > div
    &+div
      margin-top: 10px
</style>
